import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";

import Fade from "react-reveal/Fade";


const ReactSection = ({
  lightBg,
  id,
  imgStart,
  topLine,
  lightText,
  headline,
  darkText,
  description,
  description2,
  p1,
  p2,
  p3,
  buttonLabel,
  img,
  alt,
  primary,
  dark,
  dark2,
}) => {
  return (
    <>
      <InfoContainer lightBg={lightBg} id={id}>
        <Info>
          {/* <InfoRow imgStart={imgStart}> */}
            <ColumnOne>
              <TextWrapper>
                <Fade bottom>
                  <TopLine>{topLine}</TopLine>
                </Fade>
                <Fade bottom>
                  <Heading lightText={lightText}>{headline}</Heading>
                </Fade>
                <Fade bottom>
                  <Subtitle darkText={darkText}>{description}</Subtitle>
                </Fade>
                <Fade bottom>
                  <BtnWrapLink>
                    <BtnWrap>
                      <Button
                        to="templates"
                        smooth={true}
                        duration={500}
                        spy={true}
                        exact="true"
                        primary={primary ? 1 : 0}
                        offset={-80}
                        dark={dark ? 1 : 0}
                        dark2={dark2 ? 1 : 0}
                      >
                        {buttonLabel}
                      </Button>
                    </BtnWrap>
                  </BtnWrapLink>
                </Fade>
              </TextWrapper>
            </ColumnOne>
            {/* <Column2>
              <Fade left>
                <ImgWrap>
                  <Img src={img} alt={alt} />
                </ImgWrap>
              </Fade>
            </Column2> */}
          {/* </InfoRow> */}
        </Info>
      </InfoContainer>

    </>
  );
  // console.log(<Img />);
};

export default ReactSection;

const Button = styled(Link)`
font-family: "VT323", monospace;
  /* border-radius: 50px; */
  /* border-radius: 10px; */
  /* width: 50%; */
  /* background: #f7f8fa; */
  background: ${({ primary }) => (primary ? "#010606" : "#45FE47")};
  white-space: nowrap;
  padding: ${({ big }) => (big ? "14px 48px" : "12px 30px")};
  color: #010606;
  /* color: ${({ dark }) => (dark ? "#010606" : "#fff")}; */
  font-size: ${({ fontBig }) => (fontBig ? "20px" : "16px")};
  outline: none;
  border: 1px solid #010606;
  cursor: pointer;
  display: flex;
  text-decoration: none;
  justify-content: center;
  align-items: center;
  transition: all 0.2s ease-in-out;
  padding: 10px 40px 10px 40px;
  /* box-shadow: rgba(0, 0, 0, 0.1) 0px 1px 3px 0px, rgba(0, 0, 0, 0.06) 0px 1px 2px 0px; */
  &:hover {
    transition: all 0.2s ease-in-out;
    background: #010606;
    border: 1px solid #000000;
    color: #f7f8fa;
    box-shadow: none;
  }
`;

const InfoContainer = styled.div`
  color: #fff;
  background: ${({ lightBg }) => (lightBg ? "#45FE47" : "#010606")};
  /* background: ${({ lightBg }) => (lightBg ? "linear-gradient(to top, transparent, #45FE47)" : "linear-gradient(to top, transparent, #45FF46)")}; */
  border-top: 0.8px solid #010606;
  border-bottom: 0.8px solid #010606;
  @media screen and (max-width: 768px) {
    padding: 60px 0;
  }
`;

const Info = styled.div`
  display: grid;
  z-index: 1;
  padding: 80px 0px 0px 0px;
  /* width: 100%;
  max-width: 100%; */
  margin-right: auto;
  margin-left: auto;
  /* padding: 0 24px; */
  justify-content: center;
  background-color: transparent;
  @media screen and (max-width: 768px) {
    padding: 0px 20px 0px 20px;
  }
`;

export const InfoWrapper = styled.div`
  display: grid;
  z-index: 1;
  padding: 100px 0px 100px 0px;
  /* width: 100%; */
  max-width: 100%;
  margin-right: auto;
  margin-left: auto;
  /* padding: 0 24px; */
  justify-content: center;
  @media screen and (max-width: 768px) {
    padding: 0px 20px 0px 20px;
  }
`;

export const InfoRow = styled.div`
  display: grid;
  grid-auto-columns: minmax(auto, 1fr);
  align-items: center;
  grid-template-areas: ${({ imgStart }) =>
    imgStart ? `'col2 col1'` : `'col1 col2'`};

  @media screen and (max-width: 768px) {
    grid-template-areas: ${({ imgStart }) =>
      imgStart ? `'col1' 'col2'` : `'col1 col1' 'col2 col2'`};
  }
`;

export const ColumnOne = styled.div`
  margin-bottom: 15px;
  /* padding: 0 15px; */
`;

export const Column1 = styled.div`
  margin-bottom: 15px;
  padding: 0 15px;
  grid-area: col1;
`;

export const Column2 = styled.div`
  margin-bottom: 15px;
  padding: 0 15px;
  grid-area: col2;
`;

export const TextWrapper = styled.div`
  max-width: 800px;
  padding-top: 0;
  padding-bottom: 60px;
  @media screen and (max-width: 768px) {
   padding-bottom: 0px;
  }
`;

// font-family: "Orbitron", sans-serif;
// font-family: "VT323", monospace; // Keeping it "System Data" style
// color: #888;
// font-size: 1.1rem;

export const TopLine = styled.p`
 font-family: "VT323", monospace;
 color: #010606;
  /* color: #f7f8fa; */
  /* color: #44ff46; */
  font-size: 18px;
  line-height: 16px;
  font-weight: 700;
  letter-spacing: 1.4px;
  text-transform: uppercase;
  margin-bottom: 16px;
`;

export const Heading = styled.h1`
  /* font-family: "Orbitron", sans-serif; */
  font-family: "VT323", monospace;
  margin-bottom: 24px;
  font-size: 48px;
  line-height: 1.1;
  font-weight: 600;
  color: #010606;
  /* color: #f7f8fa; */
  /* color: ${({ lightText }) => (lightText ? "#f7f8fa" : "#010606")}; */
  @media screen and (max-width: 480px) {
    font-size: 32px;
  }
`;

export const Subtitle = styled.p`
font-family: "VT323", monospace;
  /* font-family: "Orbitron", sans-serif; */
  max-width: 800px;
  /* max-width: 440px; */
  margin-bottom: 35px;
  font-size: 24px;
  line-height: 24px;
  color: #010606;
  /* color: #f7f8fa; */
  /* color: ${({ darkText }) => (darkText ? "#010606" : "#f7f8fa")}; */
`;

export const BtnWrap = styled.div`
  display: flex;
  justify-content: flex-start;

`;

export const BtnWrapLink = styled(Link)`
  text-decoration: none;
`;

export const ImgWrap = styled.div`
  max-width: 555px;
  height: 100%;
`;

export const Img = styled.img`
  width: 100%;
  margin: 0 0 10px 0;
  padding-right: 0;
`;
